import React from 'react';
import axios from 'axios';

import HeaderPanel from '../Components/HeaderPanel';
import Loading from '../Components/Loading';

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import styles from '../styles/Unloading.module.css';

const Unloading = () => {
    const { openTimeModal } = useTimeModal();
    
    const [filterType, setFilterType] = React.useState('');
    const [dateStart, setDateStart] = React.useState('');
    const [dateEnd, setDateEnd] = React.useState('');
    const [region, setRegion] = React.useState('');
    const [emailAM, setEmailAM] = React.useState('');
    const [category, setCategory] = React.useState('');
    const [loading, setLoading] = React.useState(false);

    // Функция для скачивания файла
    const downloadCasesExcel = async () => {
        if (!dateStart || !dateEnd || new Date(dateStart) > new Date(dateEnd)) {
            return openTimeModal('Введите корректный период для выгрузки. Конечная дата должна быть позже, чем дата начала', 'error');
        }

        try {
            setLoading(true);
            const token = localStorage.getItem('token');

            const response = await axios.get(
                `/api/download-cases-excel?dateStart=${dateStart}&dateEnd=${dateEnd}&filterType=${filterType}&region=${region}&category=${category}`,
                {
                    responseType: 'blob',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Выгрузка_Поток_${dateStart}_по_${dateEnd}.xlsx`);
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);

            setLoading(false);
        } catch (error) {
            console.error(error);
            openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить попытку позднее'}`, 'error');
            setLoading(false);
        }
    };


    return (
        <div className='mainContainer'>
            <h1>Выгрузка данных</h1>
            <HeaderPanel typePanel='Назад' />
            {loading ? <Loading />
            : <>
                <h3 className={styles.headline}>Выгрузить таблицу всех дел за указанный период</h3>
                <a className='description'>Предварительная версия. Возможна некорректная работа</a>
                <div className={styles.line}>
                    <div>
                        <span className={styles.dateBtns}>
                            <div className={styles.dateBtn}>
                                <a>Введите дату начала учёта</a>
                                <input type="date" value={dateStart} onChange={(e) => setDateStart(e.target.value)} required />
                            </div>
                            <div style={{margin: '0 5px'}}></div>
                            <div className={styles.dateBtn}>
                                <a>Введите конечную дату учёта</a>
                                <input type="date" value={dateEnd} onChange={(e) => setDateEnd(e.target.value)} required />
                            </div>
                        </span>
                        <div style={{marginBottom: '10px'}}>
                            <a>Выберите тип даты для фильтрации</a>
                            <select className='selectMenu' value={filterType} onChange={(e) => setFilterType(e.target.value)}>
                                <option value="date_start">Дата начала учёта</option>
                                <option value="date_end">Дата окончания учёта</option>
                                <option value="date_court">Дата судебного заседания</option>
                                <option value="date_am_appointment">Дата назначения АУ</option>
                                <option value="date_submission_candidate">Дата отправки кандидатуры</option>
                            </select>
                        </div>
                        <h3 style={{ fontSize: '16px' }}>Дополнительные фильтры:</h3>
                        <p className="description">Параметры суммируются с вышеперечисленными</p>
                        <div style={{ marginTop: '10px' }}>
                            <label>
                                Укажите регион прикрепленных АУ
                                <input
                                    type="text"
                                    value={region}
                                    onChange={(e) => {
                                        setEmailAM('');
                                        setRegion(e.target.value);
                                    }}
                                    placeholder="Регион"
                                    style={{marginBottom: '0px'}}
                                    disabled={!!emailAM}
                                />
                            </label>
                            {emailAM && <p style={{ color: 'gray', fontSize: '12px' }}>Поле недоступно, так как заполнен адрес электронной почты АУ.</p>}
                        </div>
                        <div style={{marginTop: '10px'}}>
                            <label>
                                Укажите адрес электронной почты АУ
                                <input
                                    type="text"
                                    value={emailAM}
                                    onChange={(e) => {
                                        setRegion('');
                                        setEmailAM(e.target.value);
                                    }}
                                    placeholder="Email"
                                    style={{marginBottom: '0px'}}
                                    disabled={!!region}
                                />
                            </label>
                            {region && <p style={{ color: 'gray', fontSize: '12px' }}>Поле недоступно, так как заполнен регион прикрепленных АУ.</p>}
                        </div>
                        <div style={{marginTop: '10px'}}>
                            <label>
                                Укажите категорию
                                <input
                                    type="text"
                                    value={category}
                                    onChange={(e) => {
                                        setCategory(e.target.value);
                                    }}
                                    placeholder="Категория дел"
                                    style={{marginBottom: '0px'}}
                                />
                            </label>
                        </div>
                    </div>
                    <span style={{ width: '20%', display: 'flex', flexDirection: 'column' }}>
                        <button
                            className="button"
                            style={{ marginLeft: '10px' }}
                            onClick={downloadCasesExcel}
                        >
                            Скачать
                        </button>
                    </span>
                </div>
            </>}
            {/* <h3 className={styles.headline}>Последние важные действия в системе</h3>
            <div className={styles.line}>
                <a className='description'>Временно недоступно</a>
            </div> */}
        </div>
    );
};

export default Unloading;
